export const externalLinks = {
  BLOG: {
    path: 'https://blogg.bilmarked.no',
    name: 'Blogg'
  }
};